import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { GoogleAdManagerModule } from './component/google-ad-manager/google-ad-manager.module';

// Pipes
import {
	HtmlSanitizerPipe,
	MathFloorPipe,
	ObjectKeysPipe,
	StripSpecialCharsPipe,
	UrlSanitizerPipe
} from '@shared/utils/pipes';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		HtmlSanitizerPipe,
		MathFloorPipe,
		ObjectKeysPipe,
		StripSpecialCharsPipe,
		UrlSanitizerPipe
	],
	exports: [
		GoogleAdManagerModule,
		HtmlSanitizerPipe,
		MathFloorPipe,
		ObjectKeysPipe,
		StripSpecialCharsPipe,
		UrlSanitizerPipe
	]
})
export class DcsgNgxEcommerceCommonModule {}
